// extracted by mini-css-extract-plugin
export default {"ticker":"Rba","tickerItem":"Sba","tickerWrapper":"Tba","tick":"Uba","marquee":"Vba","marquee__content":"Wba"};
    if(module.hot) {
      // 1738836199106
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  